import { Button } from 'shadcn/components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'shadcn/components/ui/Dialog';

/**
 * Confirmation dialog for discarding changes when closing the modal
 * @param {object} props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {function} props.onOpenChange - Function to handle dialog open/close state
 * @param {function} props.onConfirm - Function to call when user confirms discarding changes
 * @returns {JSX.Element}
 */
function CloseConfirmationDialog({ onConfirm, onOpenChange, open }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-lg font-medium text-gray-900">Discard changes?</DialogTitle>
                    <DialogDescription className="sr-only">Confirm Discard Changes</DialogDescription>
                </DialogHeader>
                <div className="py-0">
                    <p className="text-sm text-gray-600">
                        You have unsaved changes. Are you sure you want to exit? Your changes will be lost.
                    </p>
                </div>
                <DialogFooter className="gap-3">
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button className="bg-red-600 hover:bg-red-700" onClick={onConfirm}>
                        Discard
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default CloseConfirmationDialog;
